import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'linhaOculta',
    standalone: false
})
export class LinhaOcultaPipe implements PipeTransform {

  transform(telefone: string): any {

    return '(' + telefone.substr(0,2) + ') ' + telefone.substr(2,3) + 'XX-XX' + telefone.substr(9,2);

  }

}
